export const Pending = "Pending";
export const Approved = "Approved";
export const Paid = "Paid";